import { useState, useMemo } from 'react'

import { AppLink } from '@/shared/lib/router'

import { useMissionsStore } from '../../stores/useMissionsStore'
import { MissionCard } from '../MissionCard'
import { MissionModal } from '../MissionModal'

import { Mission } from '@/features/missions/types/mission'
import { useModalContext } from '@/shared/contexts/Modal'
import { Button } from '@/shared/ui/Button'
import {
  Card,
  CardHeader,
  CardTitle,
  CardBody,
  CardFooter
} from '@/shared/ui/Card'

import { MissionFeedTile } from './Tile'

export function MissionsFeed({}) {
  const { missions } = useMissionsStore()
  const { openModal } = useModalContext()

  const handleOpenModal = (mission: Mission) => {
    openModal({ modal: MissionModal }, { missionId: mission.id })
  }

  const sortedMissions = useMemo(() => {
    const priority = (mission: Mission) => {
      if (mission.kind === 'progress' && mission.recurrence_kind === 'daily')
        return 1
      if (mission.kind === 'progress' && mission.recurrence_kind === 'weekly')
        return 2
      if (mission.kind === 'progress' && mission.recurrence_kind === 'yearly')
        return 2.5
      return 3
    }
    const newMissions = missions.sort((a, b) => priority(a) - priority(b))
    return newMissions.slice(0, 2)
  }, [missions])

  return (
    <Card variant="dark">
      <CardHeader>
        <CardTitle>Missões</CardTitle>
      </CardHeader>
      <CardBody>
        {sortedMissions.map(mission => (
          <MissionFeedTile
            key={mission.id}
            mission={mission}
            onClick={() => handleOpenModal(mission)}
          />
        ))}
      </CardBody>
      <CardFooter>
        <Button as={AppLink} href="/missoes" className="w-full">
          Ver todas
        </Button>
      </CardFooter>
    </Card>
  )
}
